import { render } from "./NavClock.vue?vue&type=template&id=1e382ab6&scoped=true"
const script = {}

import "./NavClock.vue?vue&type=style&index=0&id=1e382ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e382ab6"]])

export default __exports__